module.exports = __webpack_public_path__ + "static/image/main/season_1_character_docgo@2x.png?8fc16cdc";